module.exports = __webpack_public_path__ + "static/media/cafe24_inventory_standard.c865cc6d.png";